'use client';

import { useTranslation } from 'next-i18next';

import { Flex, Skeleton, Text, useSlotRecipe } from '@chakra-ui/react';

import { Switch } from '@nocowanie/common-ui/components/molecules/switch';
import { usePluralisationTranslation } from '@nocowanie/common-ui/hooks';
import { IconsLinear } from '@nocowanie/icons/linear';

import { ReservationSwitchProps } from '@app/components/molecules/reservation-switch';

export const ReservationSwitch = ({
    accommodationCount,
    switchProps = {},
    isLoading = false,
    variant,
    ...rest
}: ReservationSwitchProps) => {
    const recipe = useSlotRecipe({ key: 'reservationSwitch' });
    const styles = recipe({ variant });
    const { t } = useTranslation('common', { keyPrefix: 'reservationSwitch' });
    const pluralizeTranslation = usePluralisationTranslation('common');
    const { checked = false, ...restSwitchProps } = switchProps;

    return (
        <Skeleton loading={isLoading} asChild>
            <Flex data-testid={'reservation-switch-wrapper'} css={styles.wrapper} {...rest}>
                <Switch
                    labelLeft={
                        <Flex as={'span'}>
                            <IconsLinear.Flash
                                {...styles.icon}
                                size={'md'}
                                color={'selectiveYellow'}
                                fill={'selectiveYellow'}
                            />
                            <Text as={'span'} css={styles.label}>
                                {t('label', {
                                    accommodationCount: pluralizeTranslation(
                                        accommodationCount,
                                        'accommodationLabels.accommodation',
                                    ),
                                })}
                            </Text>
                        </Flex>
                    }
                    size={'sm'}
                    data-testid={'reservation-switch'}
                    checked={checked}
                    {...restSwitchProps}
                />
            </Flex>
        </Skeleton>
    );
};
